<script setup>
import Search from "../components/Search.vue";
import LocationExt from "../utils/location-ext.js";
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import {computed} from "vue";
const store = useStore();
const isInputting = computed(() => store.getters.isInputting);
const router = useRoute();
const le = new LocationExt();
if (router.params.productId) {
  const productId = parseInt(router.params.productId);
  const setProductId = (value) => store.commit('setProductId', value);
  const setBuildModel = (value) => store.commit('setBuildModel', value);
  const setSystemVersion = (value) => store.commit('setSystemVersion', value);
  const setSoftVersion = (value) => store.commit('setSoftVersion', value);
  const setSoftBuild = (value) => store.commit('setSoftBuild', value);
  const setImei = (value) => store.commit('setImei', value);
  const setGuid = (value) => store.commit('setGuid', value);
  const setBuildID = (value) => store.commit('setBuildID', value);
  const setChannel = (value) => store.commit('setChannel', value);
  const setRoot = (value) => store.commit('setRoot', value);
  const setScore = (value) => store.commit('setScore', value);
  const setUninstall = (value) => store.commit('setUninstall', value);
  setProductId(productId);
  setBuildModel(le.get('BuildModel'));
  setSystemVersion(le.get('Release'));
  setSoftVersion(le.get('VersionName'));
  setSoftBuild(le.get('Buildno'));
  setImei(le.get('imei'));
  setGuid(le.get('guid'));
  setBuildID(le.get('BuildID'));
  setChannel(le.get('channel'));
  setRoot(le.get('Root'));
  setScore(le.get('score'));
  setUninstall(le.get('uninstall'));
}
</script>

<template>
  <div :class="{ main: true, 'bg-not-inputting': !isInputting}">
    <Search/>
  </div>
</template>

<style lang="scss" scoped>
@import '~/entries/index/index.scss';
.bg-not-inputting {
  background: rgba(245, 248, 253, 1);
}
.main {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
</style>
